export default __webpack_public_path__ + "static/media/ic_status_buying.acc2da06.svg";